import { useEffect, useState } from "react";

import { ITableLookup } from "../../../../../base/models";
import { getQueryFields } from "../../../../helpers";
import { useAuth } from "../../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../../services/data/tableDataApi";

export const useLookupData = (tableLookup?: ITableLookup) => {
    const { user, siteId: portalId } = useAuth();
    const [readRecords, { isLoading }] = useLazyReadMultipleQuery()
    const [lookupData, setLookupData] = useState<{ id: string, label: string }[]>([])

    useEffect(() => {
        if (!user || !tableLookup)
            return;

        const { userId } = user;
        if (!userId || !portalId)
            return;

        if (!tableLookup.tableId || !tableLookup.idField || !tableLookup.displayField)
            return;

        const idField = tableLookup.idField;
        const displayField = tableLookup.displayField;

        var queryFields = getQueryFields([], [], tableLookup.filters || [])
        const fieldList = Array.from(new Set([...queryFields, tableLookup.idField, tableLookup.displayField]))
        const query = {
            userId, portalId,
            tableId: tableLookup.tableId,
            fieldList,
            filters: [{ group: 0, filters: tableLookup.filters || [] }],
        };

        readRecords(query)
            .unwrap()
            .then(data => {
                setLookupData(data.records.map((p) => ({ id: p[idField], label: p[displayField] })))
            })

        // eslint-disable-next-line
    }, [user, tableLookup])

    return { lookupData, isLoading }
}